import { queryOptions } from '@tanstack/react-query';

import { type EnvironmentQueryParams, environmentService } from '~api/services';

/**
 * Generate query options for fetching environment sites based on blast name and optional buffer distance
 * @param params - Query parameters including blast name and optional buffer distance
 * @returns Query options for fetching environment data
 */
function environmentQueryOptions(params: EnvironmentQueryParams) {
  return queryOptions({
    queryKey: ['environment', params],
    queryFn: () => environmentService.getEnvironment(params),
  });
}

export { environmentQueryOptions };
